var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8838 4.375C16.1921 4.375 15.6338 3.81667 15.6338 3.125C15.6338 2.43333 16.1921 1.875 16.8838 1.875H16.8921C17.5838 1.875 18.1421 2.43333 18.1421 3.125C18.1421 3.81667 17.5755 4.375 16.8838 4.375Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.13379 18.125C2.44212 18.125 1.88379 17.5667 1.88379 16.875C1.88379 16.1833 2.44212 15.625 3.13379 15.625H3.14211C3.83377 15.625 4.39211 16.1833 4.39211 16.875C4.39211 17.5667 3.82546 18.125 3.13379 18.125Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.02532 13.6666C4.81699 13.6666 4.60867 13.5583 4.492 13.3666C3.87534 12.3583 3.54199 11.1916 3.54199 9.99996C3.54199 6.44163 6.44199 3.54163 10.0003 3.54163C11.1753 3.54163 12.3253 3.8583 13.3253 4.4583C13.617 4.6333 13.717 5.01663 13.542 5.31663C13.367 5.6083 12.9837 5.70829 12.6837 5.53329C11.8753 5.04996 10.9503 4.79163 10.0087 4.79163C7.13367 4.79163 4.80033 7.12496 4.80033 9.99996C4.80033 10.9583 5.06699 11.9 5.56699 12.7166C5.75032 13.0083 5.65865 13.3916 5.35865 13.575C5.25032 13.6416 5.13366 13.6666 5.02532 13.6666Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 16.4583C8.80009 16.4583 7.63344 16.1249 6.6251 15.5083C6.33344 15.3249 6.24177 14.9416 6.41677 14.6499C6.6001 14.3583 6.98344 14.2666 7.2751 14.4416C8.09177 14.9416 9.03343 15.2083 10.0001 15.2083C12.8751 15.2083 15.2084 12.8749 15.2084 9.99995C15.2084 9.04161 14.9417 8.09995 14.4417 7.28328C14.2584 6.99162 14.3501 6.60828 14.6501 6.42495C14.9417 6.24995 15.3251 6.33328 15.5084 6.63328C16.1251 7.64995 16.4584 8.80827 16.4584 10.0083C16.4584 13.5583 13.5584 16.4583 10.0001 16.4583Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcx);
export default __webpack_public_path__ + "static/media/icx.fb0a2a4f374660b044a0ec6f87a8a27b.svg";
export { ForwardRef as ReactComponent };